/* Dealer Order Table - FNY 02.09.2026 */
(function () {
  'use strict';

  function money(cents) {
    var v = (Number(cents) / 100).toFixed(2).split('.');
    return '$' + v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + v[1];
  }
  function el(tag, cls, txt) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (txt !== null && txt !== undefined) n.textContent = txt;
    return n;
  }
  function toast(msg, isErr) {
    var t = document.querySelector('.dot-toast');
    if (!t) { t = el('div', 'dot-toast'); document.body.appendChild(t); }
    t.className = 'dot-toast' + (isErr ? ' dot-toast--err' : '');
    t.textContent = msg;
    void t.offsetWidth;
    t.classList.add('show');
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('show'); }, 3800);
  }
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function publishCart(c) {
    // 1) Tema kendi pubsub olayi (Inova): header cart-count + mini cart
    try {
      if (window.theme && theme.pubsub && theme.pubsub.PUB_SUB_EVENTS) {
        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          source: 'dealer-order-table',
          cart: c,
          cartData: c
        });
      }
    } catch (e) {}
    // 2) Dogrudan sayac yazimi (cart-count ETIKETI dahil) - pubsub yoksa yedek
    try {
      var els = document.querySelectorAll('cart-count, [data-cart-count], .cart-count, .header__cart-count, .cart-count-bubble span, .dock__item .count');
      for (var i = 0; i < els.length; i++) {
        els[i].textContent = c.item_count;
        if (els[i].tagName === 'CART-COUNT') {
          els[i].hidden = Number(c.item_count) === 0;
          els[i].setAttribute('aria-label', c.item_count + ' items');
        }
      }
    } catch (e) {}
    // 3) Sepet cekmecesini yenile (cart-drawer 'cart:refresh' dinliyor)
    try {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: c } }));
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { cart: c } }));
    } catch (e) {}
  }

  function refreshCartUi() {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { publishCart(c); return c; })
      .catch(function () { return null; });
  }

  function DOT(node) {
    this.root = node;
    this.cfg = JSON.parse(node.querySelector('[data-dot-config]').textContent);
    this.mount = node.querySelector('[data-dot-mount]');
    this.search = node.querySelector('[data-dot-search]');
    this.countEl = node.querySelector('[data-dot-count]');
    this.mode = this.cfg.default_mode || 'composite';
    this.group = null;
    this.navEl = node.querySelector('[data-dot-groupnav]');
    this.toolbar = node.querySelector('[data-dot-toolbar]');
    this.sentinel = node.querySelector('[data-dot-sentinel]');
    this.toTop = node.querySelector('[data-dot-totop]');
    this.bindCartEvents();
    this.initSticky();
    this.initTypingGuard();
    this.products = [];
    this.bind();
    this.load();
  }

  // Arac cubugu: sentinel ust kenari gecince yapisik moda gecer
  /* ---- Sepet durumu ----
   Sepete eklenen satirin butonu kalici olarak yesil kalir. Durum
   /cart.js'den okundugu icin sayfa yenilenmesi, koleksiyon degistirme
   ve sepet cekmecesinden silme islemleri de dogru yansir. */
DOT.prototype.syncCart = function () {
  var self = this;
  return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
    .then(function (r) { return r.json(); })
    .then(function (c) {
      var m = {};
      var its = (c && c.items) || [];
      for (var i = 0; i < its.length; i++) {
        var id = String(its[i].variant_id || its[i].id);
        m[id] = (m[id] || 0) + (its[i].quantity || 0);
      }
      self._cart = m;
      self.paintCart();
      return m;
    })
    .catch(function () { return null; });
};

DOT.prototype.paintCart = function () {
  var m = this._cart || {};
  var t = this.cfg.t;
  var btns = this.mount.querySelectorAll('.dot-add[data-vid]');
  for (var i = 0; i < btns.length; i++) {
    var b = btns[i];
    var q = m[b.getAttribute('data-vid')] || 0;
    var tr = b.closest('tr');
    if (q > 0) {
      b.classList.add('is-incart');
      b.setAttribute('data-qty', String(q));
      if (!b.classList.contains('is-ok')) {
        b.textContent = t.in_cart + ' \u00b7 ' + q;
      }
      b.setAttribute('aria-label', t.in_cart + ' ' + q + ' \u2014 ' + t.add_to_cart_btn);
      if (tr) { tr.classList.add('dot-row--incart'); }
    } else {
      b.classList.remove('is-incart');
      b.removeAttribute('data-qty');
      if (!b.classList.contains('is-ok') && !b.disabled) {
        b.textContent = t.add_to_cart_btn;
      }
      b.removeAttribute('aria-label');
      if (tr) { tr.classList.remove('dot-row--incart'); }
    }
  }
  this.paintCartCount();
};

/* Grup kartlarinda ve sayacta "sepette N kalem" bilgisi */
DOT.prototype.paintCartCount = function () {
  var m = this._cart || {};
  var n = 0;
  var btns = this.mount.querySelectorAll('.dot-add[data-vid]');
  for (var i = 0; i < btns.length; i++) {
    if (m[btns[i].getAttribute('data-vid')]) { n++; }
  }
  var el2 = this.root.querySelector('[data-dot-incart]');
  if (el2) {
    el2.textContent = n > 0 ? (n + ' ' + (this.cfg.t.in_cart || 'in cart').toLowerCase()) : '';
    el2.hidden = n === 0;
  }
};

/* Sepet cekmecesi / tema olaylari ile senkron */
DOT.prototype.bindCartEvents = function () {
  var self = this;
  var refresh = function () { self.syncCart(); };
  document.addEventListener('cart:refresh', refresh);
  document.addEventListener('cart:updated', refresh);
  try {
    if (window.theme && theme.pubsub && theme.pubsub.subscribe && theme.pubsub.PUB_SUB_EVENTS) {
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, refresh);
   }
  } catch (e) {}
  // sekmeye geri donuldugunde (baska sekmede sepet degismis olabilir)
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) { self.syncCart(); }
  });
};

DOT.prototype.initTypingGuard = function () {
    // FNY 09.10.2026: mobilde bir alan odaktayken (klavye acik) alt menu cubugu ve
    // yuzen sepet butonu gizlenir; icerigin ve alanin ustune binmezler.
    var root = this.root;
    var mq = window.matchMedia ? window.matchMedia('(max-width: 900px), (pointer: coarse)') : null;
    var html = document.documentElement;
    var isField = function (el) { return !!el && /^(INPUT|SELECT|TEXTAREA)$/.test(el.tagName); };
    root.addEventListener('focusin', function (e) {
      if (isField(e.target) && mq && mq.matches) { html.classList.add('dot-typing'); }
    });
    root.addEventListener('focusout', function () {
      setTimeout(function () {
        if (isField(document.activeElement) && root.contains(document.activeElement)) { return; }
        html.classList.remove('dot-typing');
      }, 300);
    });
  };

  DOT.prototype.initSticky = function () {
    var self = this;
    if (!this.toolbar || !this.sentinel) { return; }
    if (!this.toolbar.classList.contains('dot-toolbar--sticky')) { return; }

    // FNY 10.10.2026: mobil (<=900px) icin yerlesimden bagimsiz yapisma.
    // Eski yontemde arac cubugu akista sticky idi; yapisinca ~550px -> ~95px kuculup
    // tum listeyi ~440px zipliyordu. Simdi cubuk akista kalir, tamamen yukari cikinca
    // ayni yukseklikte bir yer tutucu birakip ekranin ustune sabit (fixed) kompakt bar
    // olarak gecer. Liste hic kaymaz. Masaustu eski davranisla calisir.
    var mob = window.matchMedia ? window.matchMedia('(max-width: 900px)') : null;
    var isMob = function () { return !!(mob && mob.matches); };
    var spacer = document.createElement('div');
    spacer.className = 'dot-toolbar-spacer';
    spacer.setAttribute('aria-hidden', 'true');
    spacer.hidden = true;
    this.toolbar.parentNode.insertBefore(spacer, this.toolbar);
    var compactH = 96;

    var setH = function () {
      var h = self.toolbar.getBoundingClientRect().height;
      if (isMob() && !self._stuck) { h = 0; }
      self.root.style.setProperty('--dot-toolbar-h', Math.round(h) + 'px');
    };
    setH();
    if (window.ResizeObserver) {
      this._ro = new ResizeObserver(setH);
      this._ro.observe(this.toolbar);
    }

    if (this.toTop) {
      this.toTop.addEventListener('click', function () {
        var top = self.root.getBoundingClientRect().top + window.scrollY - 20;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    }

    var place = function () {
      var r = spacer.getBoundingClientRect();
      self.toolbar.style.left = Math.round(r.left) + 'px';
      self.toolbar.style.width = Math.round(r.width) + 'px';
    };
    var setMobStuck = function (on) {
      if (on) {
        spacer.style.height = Math.round(self.toolbar.getBoundingClientRect().height) + 'px';
        spacer.hidden = false;
        self.toolbar.classList.add('is-stuck', 'is-fixed');
        place();
        compactH = Math.round(self.toolbar.getBoundingClientRect().height) || compactH;
      } else {
        self.toolbar.classList.remove('is-stuck', 'is-fixed');
        self.toolbar.style.left = '';
        self.toolbar.style.width = '';
        spacer.hidden = true;
        spacer.style.height = '';
      }
    };

    // Esik aninda IntersectionObserver top~0 yakalayip yaniltiyor;
    // sentinel rect'ini dogrudan okumak daha guvenilir.
    var check = function () {
      var off = parseInt(getComputedStyle(self.root).getPropertyValue('--dot-sticky-offset'), 10) || 12;
      var end = self.mount.getBoundingClientRect().bottom;
      var stuck;
      if (isMob()) {
        if (window.innerWidth <= 640) { off = 6; }
        var box = (self._stuck ? spacer : self.toolbar).getBoundingClientRect();
        var ae = document.activeElement;
        var typing = self._stuck && !!ae && self.toolbar.contains(ae) && /^(INPUT|SELECT|TEXTAREA)$/.test(ae.tagName);
        // alan odaktayken sonuc azalsa/bitse de cubuk birakilmaz (odaktaki alan ekranda kalir)
        stuck = box.bottom <= off + compactH && (end > off + compactH + 120 || typing);
      } else {
        if (self._mobMode) { setMobStuck(false); self._mobMode = false; self._stuck = false; }
        var top = self.sentinel.getBoundingClientRect().top;
        stuck = top <= off && end > 120;
      }
      if (stuck === self._stuck) { if (stuck && isMob()) { place(); } return; }
      self._stuck = stuck;
      if (isMob()) {
        self._mobMode = true;
        setMobStuck(stuck);
      } else {
        self.toolbar.classList.toggle('is-stuck', stuck);
      }
      if (self.toTop) { self.toTop.hidden = !stuck; }
      setH();
    };
    this._onScroll = function () {
      if (self._raf) { return; }
      self._raf = requestAnimationFrame(function () { self._raf = null; check(); });
    };
    window.addEventListener('scroll', this._onScroll, { passive: true });
    window.addEventListener('resize', this._onScroll, { passive: true });
    if (mob && mob.addEventListener) {
      mob.addEventListener('change', function () { if (self._stuck) { self._stuck = false; setMobStuck(false); self.toolbar.classList.remove('is-stuck'); } check(); });
    }
    check();
  };

  DOT.prototype.bind = function () {
    var self = this;
    var btns = this.root.querySelectorAll('[data-dot-mode]');
    for (var i = 0; i < btns.length; i++) {
      (function (b) {
        b.addEventListener('click', function () {
          self.mode = b.getAttribute('data-dot-mode');
          self.group = null;
          for (var k = 0; k < btns.length; k++) {
            btns[k].setAttribute('aria-pressed', btns[k] === b ? 'true' : 'false');
          }
          self.render();
        });
      })(btns[i]);
    }
    if (this.search) {
      var tm;
      this.search.addEventListener('input', function () {
        clearTimeout(tm);
        tm = setTimeout(function () { self.render(); }, 180);
      });
    }
  };

  /* ---- Veri yukleme (paralel + oturum onbellegi) ---- */

  var CACHE_V = 'dotv3';
  var CACHE_TTL = 15 * 60 * 1000;

  function cacheKey(handle) { return CACHE_V + ':' + handle; }
  function cacheRead(handle) {
    try {
      if (!window.sessionStorage) { return null; }
      var raw = sessionStorage.getItem(cacheKey(handle));
      if (!raw) { return null; }
      var o = JSON.parse(raw);
      if (!o || !o.t || !o.p || (Date.now() - o.t) > CACHE_TTL) { return null; }
      return o.p;
    } catch (e) { return null; }
  }
  function cacheWrite(handle, list) {
    try {
      if (!window.sessionStorage) { return; }
      sessionStorage.setItem(cacheKey(handle), JSON.stringify({ t: Date.now(), p: list }));
    } catch (e) {}
  }

  // Sadece tablonun kullandigi alanlari tut - payload ve onbellek boyutunu dusurur
  function slim(p) {
    var v = (p.variants && p.variants[0]) || {};
    return {
      product_type: p.product_type,
      title: p.title,
      handle: p.handle,
      body_html: String(p.body_html || '').split('<div class="fny-specs"')[0].replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim(),
      variants: [{ id: v.id, sku: v.sku || '', price: v.price, available: v.available !== false }]
    };
  }

  function sig(list) {
    var s = list.length + '|';
    for (var i = 0; i < list.length; i++) {
      var v = list[i].variants[0];
      s += v.sku + ':' + v.price + ':' + (v.available ? 1 : 0) + ';';
    }
    return s;
  }

  function pageUrl(handle, p) {
    return root() + 'collections/' + handle + '/products.json?limit=250&page=' + p;
  }
  function getPage(handle, p) {
    return fetch(pageUrl(handle, p), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) { return (j && j.products) || []; })
      .catch(function () { return null; });
  }

  function fetchProducts(handle, done) {
    // Ilk iki sayfa paralel (katalog 317 urun = 2 sayfa) -> ardisik yerine tek tur
    Promise.all([getPage(handle, 1), getPage(handle, 2)]).then(function (rs) {
      if (rs[0] === null) { done(null); return; }
      var all = [];
      var i;
      for (i = 0; i < rs.length; i++) { if (rs[i]) { all = all.concat(rs[i]); } }
      var lastLen = rs[rs.length - 1] ? rs[rs.length - 1].length : 0;
      if (lastLen < 250) {
        done(all.map(slim));
        return;
      }
      // Nadir durum: 500+ urun -> kalan sayfalar
      var pg = 3;
      function more() {
        getPage(handle, pg).then(function (l) {
          if (!l) { done(all.map(slim)); return; }
          all = all.concat(l);
          if (l.length === 250 && pg < 12) { pg = pg + 1; more(); }
          else { done(all.map(slim)); }
        });
      }
      more();
    }).catch(function () { done(null); });
  }

  DOT.prototype.load = function () {
    var self = this;
    var handle = this.cfg.collection_handle;
    this.mount.innerHTML = '';
    if (!handle) { this.mount.appendChild(el('div', 'dot-empty', this.cfg.t.pick_finish)); return; }

    // Parca sayilari artik sayfada gomulu - ek istek yok
    this.units = this.cfg.units || {};

    var cached = cacheRead(handle);
    if (cached && cached.length) {
      // Aninda ciz, sonra sessizce tazele (stale-while-revalidate)
      self.products = cached;
      self.render();
      fetchProducts(handle, function (fresh) {
        if (!fresh || !fresh.length) { return; }
        cacheWrite(handle, fresh);
        if (sig(fresh) !== sig(cached)) { self.products = fresh; self.render(); }
      });
      return;
    }

    this.mount.appendChild(el('div', 'dot-loading', this.cfg.t.loading));
    fetchProducts(handle, function (list) {
      if (!list) {
        self.mount.innerHTML = '';
        self.mount.appendChild(el('div', 'dot-empty', self.cfg.t.load_error));
        return;
      }
      self.products = list;
      cacheWrite(handle, list);
      self.render();
    });
  };

  // Montaj sinifi: tam SKU -> model kodu. Harita bos/eksikse null doner (tum secenekler gosterilir).
  // Renk-bagimsiz model anahtari.
  //  composite : ALFPHG-BLANCO-2DB12      -> 2DB12        (son tireden sonrasi)
  //  component : DOR_L18_H30_ALFPHG-BLANCO -> DOR_L18_H30 (son alt cizgiden oncesi)
  function modelKey(sku) {
    var s = String(sku || '');
    if (s.indexOf('_') >= 0) { return s.split('_').slice(0, -1).join('_'); }
    return s.split('-').pop();
  }

  DOT.prototype.asmClassFor = function (sku) {
    var model = modelKey(sku);

    // 1) Elle tanimlanmis istisna varsa o kazanir
    var ov = this.cfg.asm_class;
    if (ov) {
      var c = ov[sku];
      if (c === undefined || c === null) { c = ov[model]; }
      if (c) {
        c = String(c).toLowerCase();
        if (c === 'small' || c === 'large') { return c; }
      }
    }

    // 2) Paket olcusu: en uzun kenar esigin uzerindeyse Large
    var pk = this.cfg.pkg_longest;
    if (!pk) { return null; }
    var lg = pk[sku];
    if (lg === undefined || lg === null) { lg = pk[model]; }
    lg = parseFloat(lg);
    if (!lg || lg <= 0) { return null; }
    var thr = parseFloat(this.cfg.asm_large_from_in);
    if (!thr || thr <= 0) { thr = 72; }
    return (lg >= thr) ? 'large' : 'small';
  };

  // Parca sayisi: tam SKU -> model kodu (haritalar model bazli anahtarli)
  DOT.prototype.unitsFor = function (sku) {
    if (!this.units) { return 1; }
    var u = this.units[sku];
    if (u === undefined || u === null) { u = this.units[modelKey(sku)]; }
    u = parseInt(u, 10);
    if (!u || u < 1) { u = 1; }
    return u;
  };

  DOT.prototype.filtered = function () {
    var types = this.mode === 'composite' ? this.cfg.composite_types : this.cfg.component_types;
    var q = ((this.search && this.search.value) || '').trim().toLowerCase();
    var g = this.group;
    return this.products.filter(function (p) {
      if (types.indexOf(p.product_type) === -1) return false;
      if (g && p.product_type !== g) return false;
      if (!q) return true;
      var v = p.variants && p.variants[0];
      var hay = (p.title + ' ' + ((v && v.sku) || '') + ' ' + String(p.body_html || '').split('<div class="fny-specs"')[0].replace(/<[^>]*>/g, ' ')).toLowerCase();
      return hay.indexOf(q) !== -1;
    });
  };

  // Aktif moddaki gruplarin sayimi (grup filtresinden BAGIMSIZ, arama uygulanir)
  DOT.prototype.groupCounts = function () {
    var types = this.mode === 'composite' ? this.cfg.composite_types : this.cfg.component_types;
    var q = ((this.search && this.search.value) || '').trim().toLowerCase();
    var out = {};
    this.products.forEach(function (p) {
      if (types.indexOf(p.product_type) === -1) { return; }
      if (q) {
        var v = p.variants && p.variants[0];
        var hay = (p.title + ' ' + ((v && v.sku) || '') + ' ' + String(p.body_html || '').split('<div class="fny-specs"')[0]).toLowerCase();
        if (hay.indexOf(q) === -1) { return; }
      }
      out[p.product_type] = (out[p.product_type] || 0) + 1;
    });
    return out;
  };

  DOT.prototype.renderGroupNav = function () {
    var self = this;
    if (!this.navEl) { return; }
    var order = this.mode === 'composite' ? this.cfg.composite_types : this.cfg.component_types;
    var counts = this.groupCounts();
    var live = order.filter(function (t) { return counts[t]; });
    this.navEl.innerHTML = '';
    // FNY 10.10.2026: arama aktifken grup satiri gizlenmez; aksi halde yazarken
    // arac cubugu ~190px kuculup odaktaki alani (ve iOS klavyesini) zipliyordu.
    var hasQuery = !!(this.search && this.search.value && this.search.value.trim());
    if (live.length < 2 && !hasQuery) { this.navEl.hidden = true; return; }
    this.navEl.hidden = false;

    var total = 0;
    live.forEach(function (t) { total += counts[t]; });

    function card(type, label, n, imgUrl, isAll) {
      var b = el('button', 'dot-gcard' + ((isAll ? self.group === null : self.group === type) ? ' is-on' : ''));
      b.type = 'button';
      b.setAttribute('aria-pressed', (isAll ? self.group === null : self.group === type) ? 'true' : 'false');
      var box = el('span', 'dot-gcard__img');
      if (imgUrl) {
        var im = el('img');
        im.src = imgUrl; im.alt = ''; im.loading = 'lazy'; im.width = 72; im.height = 72;
        box.appendChild(im);
      } else {
        box.className = 'dot-gcard__img dot-gcard__img--ph';
        box.appendChild(el('span', null, isAll ? '\u2637' : label.replace(/[^A-Za-z ]/g, '').split(' ').map(function (w) { return w.charAt(0); }).join('').slice(0, 2).toUpperCase()));
      }
      b.appendChild(box);
      b.appendChild(el('span', 'dot-gcard__t', label));
      b.appendChild(el('span', 'dot-gcard__n', String(n)));
      b.addEventListener('click', function () {
        self.group = isAll ? null : (self.group === type ? null : type);
        self.render();
        var mnt = self.mount;
        if (mnt && mnt.getBoundingClientRect().top < 0) { mnt.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
      });
      return b;
    }

    this.navEl.appendChild(card(null, this.cfg.t.all_groups, total, null, true));
    live.forEach(function (t) {
      self.navEl.appendChild(card(t, t, counts[t], (self.cfg.group_images || {})[t] || null, false));
    });
  };

  DOT.prototype.render = function () {
    var self = this;
    this.renderGroupNav();
    var rows = this.filtered();
    this.mount.innerHTML = '';
    if (this.countEl) { this.countEl.textContent = rows.length + ' ' + this.cfg.t.items; }
    if (!rows.length) { this.mount.appendChild(el('div', 'dot-empty', this.cfg.t.no_rows)); return; }
    var order = this.mode === 'composite' ? this.cfg.composite_types : this.cfg.component_types;
    var groups = {};
    rows.forEach(function (p) {
      if (!groups[p.product_type]) { groups[p.product_type] = []; }
      groups[p.product_type].push(p);
    });
    order.forEach(function (type) {
      var list = groups[type];
      if (!list || !list.length) { return; }
      list.sort(function (a, b) {
        var sa = (a.variants[0] && a.variants[0].sku) || '';
        var sb = (b.variants[0] && b.variants[0].sku) || '';
        return sa.localeCompare(sb, undefined, { numeric: true });
      });
      var g = el('div', 'dot-group');
      g.appendChild(el('div', 'dot-group__hd', type + '  \u00b7  ' + list.length));
      var w = el('div', 'dot-tblwrap');
      var tbl = el('table', 'dot-tbl');
      var thead = el('thead');
      var tr = el('tr');
      var heads = [self.cfg.t.name, self.cfg.t.description, self.cfg.t.price, self.cfg.t.stock, self.cfg.t.add_to_cart];
      heads.forEach(function (h, i) {
        var th = el('th', null, h);
        if (i === 2) { th.style.textAlign = 'right'; }
        tr.appendChild(th);
      });
      thead.appendChild(tr);
      tbl.appendChild(thead);
      var tb = el('tbody');
      list.forEach(function (p) { self.renderRow(tb, p); });
      tbl.appendChild(tb);
      w.appendChild(tbl);
      g.appendChild(w);
      self.mount.appendChild(g);
    });
    // Yeniden cizilen satirlarda sepet durumunu geri uygula (filtre/arama/mod
    // degisiminde butonlar sifirdan olusuyor).
    if (this._cart) { this.paintCart(); } else { this.syncCart(); }
  };

  DOT.prototype.renderRow = function (tbody, p) {
    var self = this;
    var v = p.variants && p.variants[0];
    if (!v) { return; }
    var sku = v.sku || p.handle;
    var tr = el('tr');
    tr.setAttribute('data-handle', p.handle);
    tr.setAttribute('data-vid', String(v.id));

    var tdSku = el('td', 'dot-sku', sku);
    tdSku.setAttribute('data-l', this.cfg.t.name);
    /* FNY 18.10.2026: urun aciklamasina eklenen fny-specs blogu tabloda gosterilmez (catalogaudit) */
    var desc = String(p.body_html || '').split('<div class="fny-specs"')[0].replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
    if (!desc) { desc = p.title; }
    var tdDesc = el('td', 'dot-desc', desc);
    tdDesc.setAttribute('data-l', this.cfg.t.description);
    var tdPrice = el('td', 'dot-price', money(Math.round(parseFloat(v.price) * 100)));
    tdPrice.setAttribute('data-l', this.cfg.t.price);
    var tdStock = el('td', 'dot-stock');
    tdStock.setAttribute('data-l', this.cfg.t.stock);
    /* FNY 01.10.2026: durum metni span icine alindi; komponent ikonu bu hucrede, durumun altinda */
    var stTxt = el('span', 'dot-stock__t', v.available ? this.cfg.t.in_stock : this.cfg.t.out_stock);
    tdStock.className = 'dot-stock ' + (v.available ? 'dot-stock--in' : 'dot-stock--out');
    tdStock.appendChild(stTxt);

    var tdAct = el('td', 'dot-act');
    tdAct.setAttribute('data-l', this.cfg.t.add_to_cart);
    /* FNY 01.10.2026: 'Choose Assembly *' basligi kaldirildi, metin secim kutusunun ilk secenegine tasindi (eski hali: label + 'Select an option...') */
    var sel = el('select', 'dot-sel');
    sel.setAttribute('aria-label', this.cfg.t.choose_assembly + ' (required)');
    sel.required = true;
    var o0 = el('option', null, this.cfg.t.choose_assembly + ' *');
    o0.value = '';
    sel.appendChild(o0);
    // Bu dolaba uygun montaj sinifi (small / large). Tanimli degilse hepsi gosterilir.
    var asmCls = this.asmClassFor(sku);
    this.cfg.assembly.forEach(function (a) {
      var ac = a['class'] || '';
      if (asmCls && ac !== 'rta' && ac !== asmCls) { return; }
      var label = a.price_cents > 0 ? a.title + ' (+' + money(a.price_cents) + ')' : a.title;
      var o = el('option', null, label);
      o.value = String(a.variant_id);
      o.setAttribute('data-price', String(a.price_cents));
      o.setAttribute('data-title', a.title);
      sel.appendChild(o);
    });
    var row2 = el('div', 'dot-row2');
    var qty = el('div', 'dot-qty');
    var minus = el('button', null, '\u2212');
    minus.type = 'button';
    var inp = el('input');
    inp.type = 'number';
    inp.min = '1';
    inp.value = '1';
    inp.setAttribute('aria-label', sku + ' quantity');
    var plus = el('button', null, '+');
    plus.type = 'button';
    minus.addEventListener('click', function () { inp.value = String(Math.max(1, (parseInt(inp.value, 10) || 1) - 1)); });
    plus.addEventListener('click', function () { inp.value = String((parseInt(inp.value, 10) || 1) + 1); });
    qty.appendChild(minus); qty.appendChild(inp); qty.appendChild(plus);
    var add = el('button', 'dot-add', this.cfg.t.add_to_cart_btn);
    add.type = 'button';
    add.setAttribute('data-vid', String(v.id));
    row2.appendChild(qty); row2.appendChild(add);
    tdAct.appendChild(sel); tdAct.appendChild(row2);

    // Montaj adedi: varsayilan olarak dolap basina 1 adet.
    // cfg.assembly_multiply true ise composite'in parca sayisiyla carpilir.
    var units = 1;
    if (this.cfg.assembly_multiply && this.mode === 'composite') { units = this.unitsFor(sku); }
    var note = el('div', 'dot-asmnote');
    tdAct.appendChild(note);
    function updateNote() {
      var q = Math.max(1, parseInt(inp.value, 10) || 1);
      var opt = sel.options[sel.selectedIndex];
      var pr = opt ? (parseInt(opt.getAttribute('data-price'), 10) || 0) : 0;
      if (!sel.value || pr <= 0) { note.textContent = ''; return; }
      var totalQty = units * q;
      if (units <= 1) {
        // 1:1 (components modu) - carpim aciklamasi gereksiz, sadece tutar
        note.textContent = self.cfg.t.asm_total
          .replace('%total%', String(totalQty))
          .replace('%amount%', money(pr * totalQty));
        return;
      }
      note.textContent = self.cfg.t.asm_note
        .replace('%units%', String(units))
        .replace('%qty%', String(q))
        .replace('%total%', String(totalQty))
        .replace('%amount%', money(pr * totalQty));
    }
    sel.addEventListener('change', updateNote);
    inp.addEventListener('input', updateNote);
    minus.addEventListener('click', updateNote);
    plus.addEventListener('click', updateNote);

    var bomRow = null;
    var bomTd = null;
    if (this.mode === 'composite') {
      /* FNY 01.10.2026: "Show components" metin linki yerine Availability sutununda ikon buton */
      var tog = el('button', 'dot-bomicon');
      tog.type = 'button';
      tog.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" focusable="false"><path d="M12 3 2.5 8 12 13l9.5-5L12 3Z" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/><path d="m2.5 12 9.5 5 9.5-5M2.5 16l9.5 5 9.5-5" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linejoin="round"/></svg>';
      tog.setAttribute('aria-label', this.cfg.t.show_components + ' - ' + sku);
      tog.setAttribute('title', this.cfg.t.show_components);
      tog.setAttribute('aria-expanded', 'false');
      /* FNY 01.10.2026 (2): ikon Name sutununa tasindi -> [IKON] NAME */
      tdSku.textContent = '';
      var skuWrap = el('span', 'dot-sku__in');
      skuWrap.appendChild(tog);
      skuWrap.appendChild(el('span', 'dot-sku__t', sku));
      tdSku.appendChild(skuWrap);
      bomRow = el('tr', 'dot-bom');
      bomRow.style.display = 'none';
      bomTd = el('td');
      bomTd.colSpan = 5;
      bomRow.appendChild(bomTd);
      tog.addEventListener('click', function () {
        var open = bomRow.style.display !== 'none';
        bomRow.style.display = open ? 'none' : '';
        var lblNow = open ? self.cfg.t.show_components : self.cfg.t.hide_components;
        tog.setAttribute('title', lblNow);
        tog.setAttribute('aria-label', lblNow + ' - ' + sku);
        tog.setAttribute('aria-expanded', open ? 'false' : 'true');
        tog.classList.toggle('is-open', !open);
        tr.classList.toggle('dot-bom-open', !open);
        if (!open && !bomRow._loaded) { self.loadBom(p.handle, bomTd, bomRow); }
      });
    }

    add.addEventListener('click', function () {
      var q = Math.max(1, parseInt(inp.value, 10) || 1);
      if (!sel.value) {
        sel.setAttribute('data-invalid', '1');
        sel.focus();
        toast(self.cfg.t.pick_assembly, true);
        return;
      }
      sel.removeAttribute('data-invalid');
      var opt = sel.options[sel.selectedIndex];
      var asmId = parseInt(sel.value, 10);
      var asmTitle = opt.getAttribute('data-title');
      var asmPrice = parseInt(opt.getAttribute('data-price'), 10) || 0;
      var items = [];
      var props = {};
      props[self.cfg.t.prop_assembly] = asmTitle;
      props['SKU'] = sku;
      items.push({ id: v.id, quantity: q, properties: props });
      var asmQty = units * q;
      if (asmPrice > 0 || self.cfg.always_add_assembly) {
        var ap = {};
        ap[self.cfg.t.prop_for] = sku;
        // Parca carpani aktifse dokumu yaz; degilse satir adedi zaten dolap adedi
        if (units > 1) { ap[self.cfg.t.prop_units] = String(units) + ' x ' + String(q); }
        items.push({ id: asmId, quantity: asmQty, properties: ap });
      }
      var compCount = 0;
      if (bomRow && bomRow._loaded) {
        var chks = bomRow.querySelectorAll('[data-bom-vid]');
        for (var i = 0; i < chks.length; i++) {
          var c = chks[i];
          if (!c.checked) { continue; }
          var vid = parseInt(c.getAttribute('data-bom-vid'), 10);
          var bq = parseInt(c.getAttribute('data-bom-qty'), 10) || 1;
          var bp = {};
          bp[self.cfg.t.prop_component_of] = sku;
          items.push({ id: vid, quantity: bq * q, properties: bp });
          compCount = compCount + 1;
        }
      }
      add.disabled = true;
      add.textContent = self.cfg.t.adding;
      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          add.disabled = false;
          if (!res.ok) {
            add.textContent = self.cfg.t.add_to_cart_btn;
            toast((res.j && (res.j.description || res.j.message)) || self.cfg.t.add_error, true);
            return;
          }
          // Kisa "Added" flash'i, ardindan kalici sepet durumu.
          // Buton sepette oldugu surece yesil kalir; durum /cart.js'den
          // okundugu icin sayfa yenilense de korunur.
          add.textContent = self.cfg.t.added;
          add.classList.add('is-ok');
          setTimeout(function () {
            add.classList.remove('is-ok');
            self.syncCart();
          }, 1300);
          var msg = sku + ' x' + q;
          if (asmPrice > 0) { msg = msg + ' + ' + asmTitle + ' x' + asmQty; }
          if (compCount > 0) { msg = msg + ' + ' + compCount + ' ' + self.cfg.t.components_word; }
          toast(msg + ' \u2014 ' + self.cfg.t.added_suffix);
          refreshCartUi();
        })
        .catch(function () {
          add.disabled = false;
          add.textContent = self.cfg.t.add_to_cart_btn;
          toast(self.cfg.t.add_error, true);
        });
    });

    tr.appendChild(tdSku);
    tr.appendChild(tdDesc);
    tr.appendChild(tdPrice);
    tr.appendChild(tdStock);
    tr.appendChild(tdAct);
    tbody.appendChild(tr);
    if (bomRow) { tbody.appendChild(bomRow); }
  };

  DOT.prototype.loadBom = function (handle, td, bomRow) {
    var self = this;
    td.innerHTML = '';
    var box = el('div', 'dot-bom__in');
    box.appendChild(el('div', 'dot-loading', this.cfg.t.loading));
    td.appendChild(box);
    var url = root() + 'products/' + handle + '?view=bom';
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (txt) {
        var data = null;
        try { data = JSON.parse(txt); } catch (e) { data = null; }
        box.innerHTML = '';
        if (!data || !data.components || !data.components.length) {
          box.appendChild(el('div', 'dot-empty', self.cfg.t.no_bom));
          bomRow._loaded = true;
          return;
        }
        box.appendChild(el('div', 'dot-bom__hd', self.cfg.t.components_of + ' ' + (data.parent_sku || handle)));
        var t = el('table', 'dot-bomtbl');
        var th = el('thead');
        var htr = el('tr');
        /* FNY: bilesen secim kutusu kaldirildi - bos sutun da cikarildi */
        [self.cfg.t.name, self.cfg.t.description, self.cfg.t.qty_per_unit, self.cfg.t.price].forEach(function (h) {
          htr.appendChild(el('th', null, h));
        });
        th.appendChild(htr);
        t.appendChild(th);
        var tb = el('tbody');
        data.components.forEach(function (c) {
          var r = el('tr');
          /* FNY: bilesen secim kutusu kaldirildi - liste salt bilgi amacli */
          r.appendChild(el('td', 'dot-sku', c.sku || ''));
          r.appendChild(el('td', null, c.title || ''));
          r.appendChild(el('td', null, 'x' + (c.quantity || 1)));
          var pc = el('td', 'dot-price', c.price_cents != null ? money(c.price_cents) : '\u2014');
          r.appendChild(pc);
          tb.appendChild(r);
        });
        t.appendChild(tb);
        box.appendChild(t);
        /* FNY: secim kutusu kalkinca "Tick a component..." aciklamasi da gecersiz kaldi */
        bomRow._loaded = true;
      })
      .catch(function () {
        box.innerHTML = '';
        box.appendChild(el('div', 'dot-empty', self.cfg.t.load_error));
      });
  };

  function init() {
    var nodes = document.querySelectorAll('[data-dealer-order-table]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i]._dot) { continue; }
      nodes[i]._dot = new DOT(nodes[i]);
    }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', init);
})();